import React from "react";
import "./Statistic.css";

export const Statistic = ({ label, value }) => (
  <dl className="statistic">
    <dd className="statistic__value">{value}</dd>
    <dt className="statistic__label">{label}</dt>
  </dl>
);
